import React, { useState, useEffect } from 'react';
import { 
  Add 
} from '@mui/icons-material';

import FabButton from "@components/input/buttons/FabButton";
import { Button } from '@mui/material';

interface Props {
  disabled?: boolean;
  label?: string;
  no_fab?: boolean;
  label_separate?: boolean;
  onClick: () => void;
}

export default function AddButton({ 
  disabled = false,
  label = "",
  no_fab = false,
  label_separate = false,
  onClick 
}: Props) {
  const [is_disabled, setDisabled] = useState(disabled);

  useEffect(() => {
    setDisabled(disabled);
  }, [disabled]);

  const className =`${is_disabled ? " disabled" : ""}`;

  if (label === "") {
    const fab = !no_fab;
    if (fab) {
      return (
        <FabButton
          disabled={disabled} 
          onClick={onClick}>
          <Add />
        </FabButton>
      );
    } else {
      return (
        <Add className="clickable"
          onClick={onClick}
        />
      );
    }
  } else {
    if (label_separate) {
      return (
        <>
          <FabButton
            disabled={disabled} 
            onClick={onClick}>
            <Add/>
          </FabButton>&nbsp;
          <span className="header">{ label }</span>
        </>
      );
    } else {
      return (
        <Button
          className={className}
          disabled={disabled} 
          onClick={onClick}
          variant="contained" color="primary">
          <Add/>&nbsp;{ label }
        </Button>
      );
    }
  }
}
